import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { OrderTableRow } from './OrderTableRow';
import { observer } from 'mobx-react-lite';
import { Body3 } from '../../../../atomic/text/Text';
import { colors } from '../../../../../colorVars';
import { OrderTableHeader } from '../OrderTableHeader';
import ExpandButton from '../../../../atomic/buttons/expandButton/ExpandButton';
import { headerList } from '../headerList';

export const AllOrders = observer(() => {
  const { tradePlanStore } = useWebsocketStore();
  const tuOrderList = tradePlanStore.tradeUnafraidOrderList;
  const tradierOrderList = tradePlanStore.tradierOrderList;
  const [tuExpanded, setTuExpanded] = useState(true);
  const [tradierExpanded, setTradierExpanded] = useState(false);

  return (
    <>
      <thead></thead>
      <tbody>
        <tr onClick={() => setTuExpanded((prev) => !prev)}>
          <td
            colSpan={headerList.length + 1}
            style={{ border: '1px solid rgb(88, 88, 88)', minWidth: '600px' }}
          >
            <ExpandButton
              stroke={2}
              size={10}
              color={colors.lightGrey}
              direction="bottom"
              expanded={tuExpanded}
              handleClick={() => {}}
              display="inline"
              margin="0 5px 0 5px"
            />
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Trade Unafraid
            </Body3>
          </td>
        </tr>
      </tbody>
      {tuExpanded ? (
        <>
          <OrderTableHeader />
          <tbody>
            {tuOrderList.map((orderId, index) => (
              <OrderTableRow
                key={orderId + 'tradeUnafraid'}
                orderId={orderId}
                department="tradeUnafraid"
                odd={index % 2}
              />
            ))}
          </tbody>
        </>
      ) : null}
      <tbody>
        <tr onClick={() => setTradierExpanded((prev) => !prev)}>
          <td
            colSpan={headerList.length + 1}
            style={{ border: '1px solid rgb(88, 88, 88)', minWidth: '600px' }}
          >
            <ExpandButton
              stroke={2}
              size={10}
              color={colors.lightGrey}
              direction="bottom"
              expanded={tradierExpanded}
              handleClick={() => {}}
              display="inline"
              margin="0 5px 0 5px"
            />
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Broker
            </Body3>
          </td>
        </tr>
      </tbody>
      {tradierExpanded ? (
        <>
          <OrderTableHeader />
          <tbody>
            {tradierOrderList.map((orderId, index) => (
              <OrderTableRow
                key={orderId + 'tradier'}
                orderId={orderId}
                department="tradier"
                odd={index % 2}
              />
            ))}
          </tbody>
        </>
      ) : null}
    </>
  );
});

AllOrders.propTypes = {
  size: PropTypes.string,
};
